import {
  AnswerThemeTag_AnswerThemeFragment,
  SurveyQuestionModalDocument,
  useAnswerThemeTag_AnswerThemeDeleteMutation,
} from '@/graphql/generated';
import clsx from 'clsx';
import { useState } from 'react';
import { useToast } from '@/components/layout/Toast';
import { Loader } from '@/components/generic/Loader';
import { useAnalysisThemeModal } from './AnalysisThemeModal';
import { XIcon } from '@/components/icons';
import { useTranslation } from '@/hooks/useTranslation';

export default function AnswerThemeTag({
  answerTheme,
}: {
  answerTheme: AnswerThemeTag_AnswerThemeFragment;
}) {
  const { t } = useTranslation();
  const toast = useToast();
  const [isDeleting, setIsDeleting] = useState(false);
  const { openThemeModal } = useAnalysisThemeModal();

  const [answerThemeDeleteMutation] =
    useAnswerThemeTag_AnswerThemeDeleteMutation({
      refetchQueries: [
        {
          query: SurveyQuestionModalDocument,
          variables: {
            id: answerTheme.question.id,
          },
        },
      ],
    });
  const deleteSurveyTheme = () => {
    setIsDeleting(true);
    answerThemeDeleteMutation({ variables: { id: answerTheme.id } })
      .catch((err) => {
        console.error(err);
      })
      .then(() => {
        toast.openToastWithMessage(t('toast:analysis_themes.delete.success'));
      })
      .finally(() => setIsDeleting(false));
  };

  return (
    <div className={clsx('tag', answerTheme.analysisTheme.color)}>
      <span
        title={answerTheme.analysisTheme.name}
        className="cursor-pointer max-w-[10rem] truncate text-ellipsis sami-body-bold"
        onClick={() => openThemeModal(answerTheme.analysisTheme.id)}
      >
        {answerTheme.analysisTheme.name}
      </span>
      {isDeleting ? (
        <Loader className="w-3 h-3" />
      ) : (
        <XIcon
          className="w-3 h-3 cursor-pointer opacity-60 hover:opacity-100"
          onClick={deleteSurveyTheme}
        />
      )}
    </div>
  );
}
